import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import type { ReactNode } from 'react'

interface Props {
  children?: () => ReactNode
}

const PingModelerService = ({ children }: Props) => {
  const url = `${MODELER_SERVICE}/ping`

  return (
    <AuthenticatedDataRequest
      method='get'
      url={url}
    >
      {children}
    </AuthenticatedDataRequest>
  )
}

export default PingModelerService
